module.exports = __webpack_public_path__ + "img/vertical_3_4_4.6385eef5.png";